const newsletter = `
# eBL Newsletter 16

## 14 May 2024

### Fragmentarium

- Several collections of dates (the BM catalogues of the Babylon Collection and
  the Sippar Collection as well as Everling’s Repertoire) have been imported
  into the Fragmentarium. There are currently **29,098** tablets with a
  \`date\` (**27,089** Neo-Babylonian or later).
- The Sultantepe tablets have been reworked. The museum in which they are kept
  (Ankara or Şanlıurfa) has been added, courtesy of S. Adalı. O. R. Gurney’s
  articles containing corrections have been systematically added to the
  references. All dates and findspots have been added.
- The Folios of H. H. Figulla have been added, courtesy of M. Molina who
  digitized them.
- New features
  - **Colophons**: It is now possible to add information about a tablet’s
  colophon, including provenance, individuals mentioned, etc. The field will be
  populated with the database from the [Reading the Library of Ashurbanipal
  Project](https://oracc.museum.upenn.edu/asbp/rlasb/project/index.html) soon.
- It is possible now to search by provenance.

### About & Tools

- **Signs**: Provenance is now displayed by the sign snippets.
- New sections
  - **Project**: Projects can now have individual pages, which include
  information about the project, a list of tablets and texts edited, etc. 
  Compare the page of the Cuneiform Artefacts of Iraq in Context project:
  [CAIC](https://www.ebl.lmu.de/projects/CAIC).
  - **About/News**: All eBL Newsletters are archived here.

- **eBL Evenings**: We will be hosting regular Zoom sessions to showcase its
  features and tools. These sessions will include a Q&A – please feel free to
  submit questions in advance via [e-mail](mailto:ebl-info@culture.lmu.de).
  The second session is scheduled for May 31st at 6:00 PM CET. This time we
  shall focus on the Editors’ work. If you would like to attend, please register 
  [here](https://lmu-munich.zoom-x.de/meeting/register/u5cldemhqDwtGtR-CKF5V1fnntrrTsYbLXEf).`

export default newsletter
